import React, { useState, useEffect } from "react";
//import "./bundesliga.css";
import { Helmet } from "react-helmet-async";
const clubName = "Borussia Dortmund";
const lastWin = "2012";

// Date when Chelsea FC last won the Premier League title (2016/17 season)
const clubLastPremierLeagueWinDate = new Date("2012-05-05T00:00:00Z");

const calculateTimeSpan = () => {
  const now = new Date();
  const timeDiff = now - clubLastPremierLeagueWinDate;

  const years = Math.floor(timeDiff / (1000 * 60 * 60 * 24 * 365));
  const months = Math.floor((timeDiff % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24 * 30));
  const weeks = Math.floor((timeDiff % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24 * 7));
  const days = Math.floor((timeDiff % (1000 * 60 * 60 * 24 * 7)) / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

  return { years, months, weeks, days, hours, minutes, seconds };
};

function BorussiaDortmund() {
  const [timeSpan, setTimeSpan] = useState(calculateTimeSpan());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeSpan(calculateTimeSpan());
    }, 1000); // update every second

    return () => clearInterval(interval); // cleanup interval on unmount
  }, []);

  return (
       <>
         <Helmet>
         <title>
          FootyTick
         </title>
       
         <meta
           name="description"
           content={`Track Bundesliga clubs latest championship updates on FootyTick.`}
         />
       
         <meta
           property="og:title"
           content={`FootyTick | Bundesliga`}
         />
       
         <meta
           property="og:description"
           content={`See Bundesliga footbal clubs latest championship timestamp.`}
         />
       </Helmet>
       
    
    
       <div className="league-app">
         <h1>{clubName} ({lastWin})</h1>
         <div className="time-container">
           <div className="time-box">
             <span>{timeSpan.years}</span>
             <span>{timeSpan.years < 2 ? "Year" : "Years"}</span>
           </div>
           <div className="time-box">
             <span>{timeSpan.months}</span>
             <span>{timeSpan.months < 2 ? "Month" : "Months"}</span>
           </div>
           <div className="time-box">
             <span>{timeSpan.weeks}</span>
             <span>{timeSpan.weeks < 2 ? "Week" : "Weeks"}</span>
           </div>
           <div className="time-box">
             <span>{timeSpan.days}</span>
             <span>{timeSpan.days < 2 ? "Day" : "Days"}</span>
           </div>
           <div className="time-box">
             <span>{timeSpan.hours}</span>
             <span>{timeSpan.hours < 2 ? "Hour" : "Hours"}</span>
           </div>
           <div className="time-box">
             <span>{timeSpan.minutes}</span>
             <span>{timeSpan.minutes < 2 ? "Minute" : "Minutes"}</span>
           </div>
           <div className="time-box sec-box">
             <span className="time-sec">{timeSpan.seconds}</span>
             <span>{timeSpan.seconds < 2 ? "Second" : "Seconds"}</span>
           </div>
         </div>
       </div>
        </>
  );
}

export default BorussiaDortmund;